import React from 'react';
import { Footer } from '../Common/Footer';
import { AffiliatorSidebar } from '../Common/AffiliatorSidebar';
import { AffiliatorDashboardHeader } from '../Common/AffiliatorDashboardHeader';
import { Link } from 'react-router-dom'
import { Header } from '../Common';
import AffiliatorLinks from '../../Models/AffiliatorLinks';
import ReactTooltip from 'react-tooltip'
import Affiliator from '../../Models/Affiliator';
class ActiveThisMonth extends React.Component {
    constructor(props) {
        super(props);
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '' || x.user_type_id !== 3) {
            alert('ログインしてください')
            window.location.href = '/login/affiliator';
        };
        this.state = {
            _id: false,
            newusers: []
        };
        this.allActive();
    }
    componentDidMount() {
        let x = JSON.parse(localStorage.getItem('info'))
        window.scrollTo(0, 0)
    }
    allActive() {
        let x = JSON.parse(localStorage.getItem('info'))
        Affiliator.activeChildList(x.id).then(res => {
            console.log(res.data)
            this.setState({ 
                newusers: res.data.list
            })
            console.log(this.state.newusers)
        })
    }
   
    
    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if(isMobile){
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid" style={{minHeight: "600px"}}>
                        <div className="">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className=" mb-1 input_name big_font guide_text" style={{width:'100%', fontSize: "20px"}}>
                                        <strong>アクティブ</strong>
                                    </div>
                                    <div>
                                        <table style={{width: "100%"}}>
                                            <tbody style={{borderCollapse: "collapse"}}>
                                                {this.state.newusers.map(newu =>
                                                    <tr className="tr-bottom" style={{width: "100%"}}>
                                                        <td style={{width: "65%", borderBottom: "1px solid #ccd0c9", padding: "1%", fontSize: "12px"}}>{newu.first_name}</td>
                                                        <td style={{width: "35%", borderBottom: "1px solid #ccd0c9", fontSize: "12px"}}>{newu.expense}</td>
                                                    </tr>
                                                )}
                                            </tbody>   
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div >
            )
        } else {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4 input_name">
                                        <AffiliatorSidebar />
                                    </div>
                                    <div className="col-md-8">
                                        <div className="mb-3 input_name big_font guide_text pages_headers" style={{ width: '100%' }}>
                                            アクティブ
                                        </div>
                                        <div>
                                            <table style={{width: "100%"}}>
                                                <tbody style={{borderCollapse: "collapse"}}>
                                                    {this.state.newusers.map(newu =>
                                                        <tr style={{width: "100%"}}>
                                                            <td style={{width: "65%", fontSize: "14px"}}>{newu.first_name}</td>
                                                            <td style={{width: "35%", fontSize: "14px"}}>{newu.expense}</td>
                                                        </tr>
                                                    )}
                                                </tbody>   
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div >
                    <Footer />
                </div >
            )
        }
        
    }
}
export { ActiveThisMonth }